import { makeDynamicConfigWidgets } from '~/helper/makeDynamicConfigWidgets';

const DEFAULT_COLS = 8;

export const cockpitCalendarWidgets = makeDynamicConfigWidgets([
  {
    name: 'cockpitCalendarEventsWidget',
    cols: DEFAULT_COLS,
    props: {
      title: 'cockpit_calendar_events_widget_title',
      hideViewAllButton: true,
    },
  },
  {
    name: 'cockpitCalendarEventsUpcomingWidget',
    cols: DEFAULT_COLS,
    props: {
      title: 'cockpit_calendar_events_upcoming_widget_title',
    },
  },
  {
    name: 'cockpitCalendarEventsPastWidget',
    cols: DEFAULT_COLS,
    props: {
      title: 'cockpit_calendar_events_past_widget_title',
    },
  },
]);
